import { createRouter, createWebHistory } from 'vue-router'

import Layout from '@/layout/'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
    meta: { requireAuth: false }
  },
  {
    path: '/oauth2',
    name: 'oauth2',
    component: () => import('@/views/login/oauth2'),
    meta: { requireAuth: false }
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import('@/views/home/preview')
  },
  {
    path: '/',
    //name: 'layout',
    component: Layout,
    children: [{
      path: '/',
      name: 'Default',
      component: () => import('@/views/home/default')
    },
    {
      path: '/console',
      name: 'Console',
      component: () => import('@/views/home/console')
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/views/home/index')
    },
    {
      path: '/version',
      name: 'version',
      component: () => import('@/views/home/version')
    }
    ]
  },
  {
    path: '/sys/',
    component: Layout,
    children: [{
      path: 'menu',
      name: 'Menu',
      component: () => import('@/views/sys/menu/index')
    },
    {
      path: 'role',
      name: 'Role',
      component: () => import('@/views/sys/role/index')
    },
    {
      path: 'user',
      name: 'User',
      component: () => import('@/views/sys/user/index')
    },
    {
      path: 'userReset',
      name: 'UserReset',
      component: () => import('@/views/sys/user/reset')
    },
    {
      path: 'dictionary',
      name: 'Dictionary',
      component: () => import('@/views/sys/dictionary/index')
    },
    {
      path: 'company',
      name: 'Company',
      component: () => import('@/views/sys/company/index')
    },
    {
      path: 'department',
      name: 'Department',
      component: () => import('@/views/sys/department/index')
    },
    {
      path: 'message',
      name: 'Message',
      component: () => import('@/views/sys/message/index')
    },
    {
      path: 'message/detail/:id',
      name: 'MessageDetail',
      component: () => import('@/views/sys/message/detail')
    }
    ]
  },
  {
    path: '/stock/',
    component: Layout,
    children: [{
      path: 'product/spulist',
      name: 'SpuList',
      component: () => import('@/views/stock/product/spulist')
    },
    {
      path: 'product/skulist',
      name: 'SkuList',
      component: () => import('@/views/stock/product/skulist')
    },
    // {
    //   path: 'product/skudetail',
    //   name: 'SkuDetail',
    //   component: () => import('@/views/stock/product/skudetail')
    // },
    {
      path: 'bills/index',
      name: 'BillIndex',
      component: () => import('@/views/stock/bills/index')
    },
    {
      path: 'bills/inlist',
      name: 'billInList',
      component: () => import('@/views/stock/bills/inlist')
    },
    {
      path: 'bills/indetail',
      name: 'billInDetail',
      component: () => import('@/views/stock/bills/indetail')
    },
    {
      path: 'bills/detail',
      name: 'BillDetail',
      component: () => import('@/views/stock/bills/detail')
    },
    {
      path: 'bills/instore',
      name: 'Instore',
      component: () => import('@/views/stock/bills/instore')
    },
    {
      path: 'bills/crossTransfer',
      name: 'CrossTransfer',
      component: () => import('@/views/stock/bills/crossTransfer')
    },
    {
      path: 'bills/pendingReturn',
      name: 'PendingReturnManage',
      component: () => import('@/views/stock/bills/pendingList')
    },
    {
      path: 'bills/pendingReturnDetail',
      name: 'PendingReturnDetail',
      component: () => import('@/views/stock/bills/pendingDetail')
    },
    {
      path: 'bills/repair',
      name: 'RepairManage',
      component: () => import('@/views/stock/bills/pendingList')
    },
    {
      path: 'bills/repairDetail',
      name: 'RepairDetail',
      component: () => import('@/views/stock/bills/pendingDetail')
    },
    {
      path: 'bills/gold',
      name: 'GoldManage',
      component: () => import('@/views/stock/bills/pendingList')
    },
    {
      path: 'bills/goldDetail',
      name: 'GoldDetail',
      component: () => import('@/views/stock/bills/pendingDetail')
    },
    
    {
      path: 'bills/:billType',
      name: 'billsDynamic',
      component: () => import('@/views/stock/bills/index'),
      props: true
    },
    {
      path: 'bills/borrowDetail',
      name: 'Borrow',
      component: () => import('@/views/stock/bound/borrow')
    },

    {
      path: 'bills/outstore',
      name: 'Outstore',
      component: () => import('@/views/stock/bills/outstore')
    },
    {
      path: 'bills/assemble',
      name: 'Assemble',
      component: () => import('@/views/stock/bills/assemble')
    },
    {
      path: 'bills/assembleDetail',
      name: 'AssembleDetail',
      component: () => import('@/views/stock/bills/assembleDetail')
    },
    {
      path: 'bills/assembleSplit',
      name: 'AssembleSplit',
      component: () => import('@/views/stock/bills/assembleSplit')
    },
    {
      path: 'check/index',
      name: 'CheckIndex',
      component: () => import('@/views/stock/check/index')
    },
    {
      path: 'check/detail',
      name: 'CheckDetail',
      component: () => import('@/views/stock/check/detail')
    },
    {
      path: 'check/stockCheck',
      name: 'StockCheck',
      component: () => import('@/views/stock/check/stockCheck')
    },
    {
      path: 'store/index',
      name: 'StoreIndex',
      component: () => import('@/views/stock/store/index')
    },
    {
      path: 'bound/index',
      name: 'BoundIndex',
      component: () => import('@/views/stock/bound/index')
    },
    {
      path: 'bound/:dynamic',
      name: 'boundDynamic',
      component: () => import('@/views/stock/bound/index'),
      props: true
    },
    {
      path: 'bound/detail',
      name: 'BoundDetail',
      component: () => import('@/views/stock/bound/detail')
    },
    {
      path: 'boundTemp/index',
      name: 'StockBoundTemp',
      component: () => import('@/views/stock/boundTemp/index')
    },
    {
      path: 'material/index',
      name: 'StockMaterialBill',
      component: () => import('@/views/stock/material/index')
    },
    {
      path: 'material/stores',
      name: 'StockMaterialStores',
      component: () => import('@/views/stock/material/stores')
    },
    {
      path: 'material/dispatched',
      name: 'StockMaterialDispatched',
      component: () => import('@/views/stock/material/dispatched')
    },
    {
      path: 'material/stored',
      name: 'StockMaterialForm',
      component: () => import('@/views/stock/material/stored')
    },
    {
      path: 'material/received',
      name: 'StockMaterialReceived',
      component: () => import('@/views/stock/material/received')
    },
    {
      path: 'outOrder/index',
      name: 'outOrderIndex',
      component: () => import('@/views/stock/outOrder/index')
    },
    {
      path: 'outOrder/detail',
      name: 'outOrderDetail',
      component: () => import('@/views/stock/outOrder/detail')
    },
    {
      path: 'taxticket/index',
      name: 'taxticket',
      component: () => import('@/views/stock/taxticket/index')
    },
    {
      path: 'report/sellreport',
      name: 'sellreport',
      component: () => import('@/views/stock/report/sellreport')
    },
    {
      path: 'report/boundday',
      name: 'boundday',
      component: () => import('@/views/stock/report/boundday')
    },
    
    {
      path: 'purchase/index',
      name: 'StockPurchaseIndex',
      component: () => import('@/views/stock/purchase/index')
    },
    {
      path: 'purchase/detail',
      name: 'StockPurchaseDetail',
      component: () => import('@/views/stock/purchase/detail')
    },
    {
      path: 'application',
      name: 'StockApplication',
      component: () => import('@/views/stock/application')
    },
    ]
  },

  {
    path: '/workflow/',
    component: Layout,
    children: [{
      path: 'instance',
      name: 'instance',
      component: () => import('@/views/workflow/instance')
    }, {
      path: 'application',
      name: 'application',
      component: () => import('@/views/workflow/application')
    }, {
      path: 'configer',
      name: 'configer',
      component: () => import('@/views/workflow/flowConfiger')
    },
    {
      path: 'flowdraw',
      name: 'flowdraw',
      component: () => import('@/views/workflow/flowDraw')
    },
    {
      path: 'flowForm',
      name: 'flowForm',
      component: () => import('@/views/workflow/flowForm')
    },
    {
      path: 'flowHistory',
      name: 'flowHistory',
      component: () => import('@/views/workflow/flowHistory')
    },
    {
      path: 'flowArticle',
      name: 'flowArticle',
      component: () => import('@/views/workflow/article/index')
    },
    
    {
      path: 'articlePaper',
      name: 'articlePaper',
      component: () => import('@/views/workflow/article/paper')
    },
    {
      path: 'articleList',
      name: 'articleList',
      component: () => import('@/views/workflow/article/index')
    },
    {
      path: 'articleDetail',
      name: 'articleDetail',
      component: () => import('@/views/workflow/article/detail')
    },
    {
      path: 'articlePusher',
      name: 'articlePusher',
      component: () => import('@/views/workflow/article/pusher')
    },
    ]
  },

  {
    path: '/mail/',
    component: Layout,
    children: [
      {
        path: 'scale/index',
        name: 'ScaleIndex',
        component: () => import('@/views/mail/scale/index')
      },
      {
        path: 'scale/scale',
        name: 'scaleDetail',
        component: () => import('@/views/mail/scale/scale')
      },
      {
        path: 'bill/index',
        name: 'billIndex',
        component: () => import('@/views/mail/bill/index')
      },
      {
        path: 'bill/detail',
        name: 'billDetail',
        component: () => import('@/views/mail/bill/detail')
      },
      {
        path: 'other/index',
        name: 'otherIndex',
        component: () => import('@/views/mail/other/index')
      },
      {
        path: 'other/detail',
        name: 'otherDetail',
        component: () => import('@/views/mail/other/detail')
      },
      {
        path: 'union/index',
        name: 'UnionIndex',
        component: () => import('@/views/mail/union/index')
      },
      {
        path: 'union/detail',
        name: 'UnionDetail',
        component: () => import('@/views/mail/union/detail')
      },
      {
        path: 'partner/index',
        name: 'PartnerIndex',
        component: () => import('@/views/mail/partner/index')
      },
      {
        path: 'partner/detail',
        name: 'PartnerDetail',
        component: () => import('@/views/mail/partner/detail')
      }
    ]
  },

  {
    path: '/order/',
    component: Layout,
    children: [{
      path: 'preInfo',
      name: 'preInfo',
      component: () => import('@/views/order/preInfo/index')
    },
    {
      path: 'preInfo0',
      name: 'preInfo0',
      component: () => import('@/views/order/preInfo/index?status=0'),
      meta: { status: 0 }
    },
    {
      path: 'preInfo10',
      name: 'preInfo10',
      component: () => import('@/views/order/preInfo/index?status=10'),
      meta: { status: 10 }
    },
    {
      path: 'preInfo20',
      name: 'preInfo20',
      component: () => import('@/views/order/preInfo/index?status=20'),
      meta: { status: 20 }
    },
    {
      path: 'preInfo30',
      name: 'preInfo30',
      component: () => import('@/views/order/preInfo/index?status=30'),
      meta: { status: 30 }
    },
    {
      path: 'upload',
      name: 'upload',
      component: () => import('@/views/order/preInfo/upload')
    },
    {
      path: 'detail',
      name: 'orderDetail',
      component: () => import('@/views/order/preInfo/detail')
    },
    {
      path: 'printInfo',
      name: 'printInfo',
      component: () => import('@/views/order/printInfo/index')
    },
    {
      path: 'printPdd',
      name: 'printPdd',
      component: () => import('@/views/order/printInfo/pddprint')
    },
    {
      path: 'printHistory',
      name: 'printHistory',
      component: () => import('@/views/order/printInfo/history')
    },
    {
      path: 'returnInfo',
      name: 'orderReturn',
      component: () => import('@/views/order/return/index')
    },
    {
      path: 'returnInfo10',
      name: 'returnInfo10',
      component: () => import('@/views/order/return/index?status=10'),
      meta: { status: 10 }
    },
    {
      path: 'returnInfo50',
      name: 'returnInfo50',
      component: () => import('@/views/order/return/index?status=50'),
      meta: { status: 50 }
    },
    {
      path: 'returnInfo200',
      name: 'returnInfo200',
      component: () => import('@/views/order/return/index?status=200'),
      meta: { status: 200 }
    },
    {
      path: 'addReturn',
      name: 'addReturn',
      component: () => import('@/views/order/return/addreturn')
    },]
  },

  {
    path: '/diamond/',
    component: Layout,
    children: [{
      path: 'stock/index',
      name: 'stockIndex',
      component: () => import('@/views/diamond/stock/index')
    }
    ]
  },

  {
    path: '/logs/',
    component: Layout,
    children: [{
      path: 'apilogs',
      name: 'apiLogs',
      component: () => import('@/views/sys/logs/apilogs')
    }, {
      path: 'operatelog',
      name: 'operatelog',
      component: () => import('@/views/sys/logs/operatelog')
    }]
  },

  {
    path: '/hrdata/',
    component: Layout,
    children: [{
      path: 'signlog',
      name: 'signlog',
      component: () => import('@/views/hrdata/signlog')
    }, {
      path: 'employee',
      name: 'employee',
      component: () => import('@/views/hrdata/employee')
    }, {
      path: 'salary',
      name: 'salary',
      component: () => import('@/views/hrdata/salary')
    }, {
      path: 'personal',
      name: 'personal',
      component: () => import('@/views/hrdata/personal')
    }]
  },

  {
    path: '/fund/',
    component: Layout,
    children: [{
      path: 'fundflowlog',
      name: 'fundflowlog',
      component: () => import('@/views/fund/fundflowlog')
    }, {
      path: 'fundreport',
      name: 'fundreport',
      component: () => import('@/views/fund/fundreport')
    }, {
      path: 'ordersell',
      name: 'ordersell',
      component: () => import('@/views/fund/ordersell')
    }, {
      path: 'fundbilllog',
      name: 'fundbilllog',
      component: () => import('@/views/fund/fundbilllog')
    }, {
      path: 'calculator',
      name: 'calculator',
      component: () => import('@/views/fund/calculator')
    }, {
      path: 'fundbankinfo',
      name: 'FundBankInfo',
      component: () => import('@/views/fund/fundbankinfo')
    }]
  },

  {
    path: '/demo/',
    component: Layout,
    children: [{
      path: 'signalr',
      name: 'SignalR',
      component: () => import('@/views/demo/signalr')
    }, {
      path: 'flowchart',
      name: 'Flowchart',
      component: () => import('@/views/demo/flowchart')
    },]
  },
  // {
  //   path: '/Finance/',
  //   component: Layout,
  //   children: [{
  //     path: 'InventoryInquiry',
  //     name: 'InventoryInquiry',
  //     component: () => import('@/views/Finance/InventoryInquiry')
  //   }, {
  //     path: 'InventoryDetail',
  //     name: 'InventoryDetail',
  //     component: () => import('@/views/Finance/InventoryDetail')
  //   }, {
  //     path: 'PriceRate',
  //     name: 'PriceRate',
  //     component: () => import('@/views/Finance/PriceRate')
  //   }]
  // },
  {
    path: '/shop/',
    component: Layout,
    children: [{
      path: 'category',
      name: 'category',
      component: () => import('@/views/shop/category')
    },{
      path: 'order',
      name: 'order',
      component: () => import('@/views/shop/order')
    },{
      path: 'product',
      name: 'product',
      component: () => import('@/views/shop/product')
    },{
      path: 'user',
      name: 'user',
      component: () => import('@/views/shop/user')
    },{
      path: 'refund',
      name: 'refund',
      component: () => import('@/views/shop/refund')
    }]
  },
  {
    path: '/purchase/',
    component: Layout,
    children: [{
      path: 'supplier',
      name: 'PurchaseSupplier',
      component: () => import('@/views/purchase/supplier/index')
    },{
      path: 'supplier/detail',
      name: 'PurchaseSupplierDetail',
      component: () => import('@/views/purchase/supplier/detail')
    },{
      path: 'brand',
      name: 'PurchaseBrand',
      component: () => import('@/views/purchase/brand/index')
    },{
      path: 'brand/detail',
      name: 'PurchaseBrandDetail',
      component: () => import('@/views/purchase/brand/detail')
    },{
      path: 'requisition',
      name: 'PurchaseRequisition',
      component: () => import('@/views/purchase/requisition/index')
    },{
      path: 'requisition/detail',
      name: 'PurchaseRequisitionDetail',
      component: () => import('@/views/purchase/requisition/detail')
    },{
      path: 'order',
      name: 'PurchaseOrder',
      component: () => import('@/views/purchase/order/index')
    },{
      path: 'order/detail',
      name: 'PurchaseOrderDetail',
      component: () => import('@/views/purchase/order/detail')
    },
    {
      path: 'delivery',
      name: 'PurchaseDelivery',
      component: () => import('@/views/purchase/delivery/index')
    },{
      path: 'delivery/detail',
      name: 'PurchaseDeliveryDetail',
      component: () => import('@/views/purchase/delivery/detail')
    },{
      path: 'delivery/detailList',
      name: 'PurchaseDeliveryDetailList',
      component: () => import('@/views/purchase/delivery/detailList')
    }]
  },
  {
    path: '/platform',
    component: Layout,
    redirect: '/platform/config',
    meta: { title: '平台管理', icon: 'platform' },
    children: [
      {
        path: 'config',
        name: 'PlatformConfig',
        component: () => import('@/views/platform/config/index.vue'),
        meta: { title: '平台配置', requireAuth: true }
      },
      {
        path: 'shop',
        name: 'PlatformShop',
        component: () => import('@/views/platform/shop/index.vue'),
        meta: { title: '店铺管理', requireAuth: true }
      },
      {
        path: 'auth',
        name: 'PlatformAuth',
        component: () => import('@/views/platform/auth/index.vue'),
        meta: { title: '授权管理', requireAuth: true }
      },
      {
        path: 'apilog',
        name: 'PlatformApiLog',
        component: () => import('@/views/platform/apilog/index.vue'),
        meta: { title: '接口日志', requireAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), routes
})

//路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }

  //判断是否为true，如果为true就是要登录，去判断token是否存在。存在就执行，不存在就跳转登录页面
  if (to.meta.requireAuth == undefined || to.meta.requireAuth) {
    if (sessionStorage.getItem('access_token')) {
      next() //允许通过
    } else {
      next('/login?redirectUrl=' + encodeURIComponent(location.pathname + location.search))
    }
  } else {
    next()
  }
})

export default router
